<template>
    <div class="supplier">

      <progress-view :loading="isLoading"></progress-view>

      <v-container fluid v-if="!isLoading">
        <v-row>
          <v-col cols="10" class="p-0" >

            <v-container>
              <v-row>
                <v-col>
                  <priority-chip :priority="supplier.priority" />                                    
                  <h4 class="mb-2">
                    {{supplier.name}}
                    <router-link :to="{ name: 'supplier_edit', params: { sup_cd: sup_cd }}"> <v-icon>mdi-pencil-box</v-icon> </router-link>
                  </h4>                  
                  
                  <table class="basicinfo">
                    <tr><th>住所</th>
                      <td>
                      {{ supplier.address1 }}
                      <br v-if="supplier.address2">{{ supplier.address2 }}
                      <br v-if="supplier.address3">{{ supplier.address3 }}
                      </td>
                    </tr>
                    <tr><th>TEL</th><td>{{ supplier.tel }}</td></tr>
                    <tr><th>FAX</th><td>{{ supplier.fax }}</td></tr>                    
                    <tr><th>登録CD</th><td><span v-if="!supplier.systemCd">未登録</span><span v-else>{{ supplier.systemCd }}</span></td></tr>
                    <tr><th>登録日</th><td>{{ this.formatDateToDisplay(supplier.createAt) }}</td></tr>
                    <tr><th>取扱会社</th><td><contractor-chip v-for="cnt in supplier.contractors" :key="cnt"  :contractor_cd="cnt"></contractor-chip></td></tr>
                    <tr><th>対応工程</th><td><v-chip v-for="pg in supplier.processGroups" :key="pg.processGroupCd" class="my-1 ml-1" small>{{ pg.processGroupName }}</v-chip></td></tr>
                  </table>

                </v-col>
                <v-col>

                  <v-sheet v-if="supplier.mainPhotoId">
                    <div style="width:300px">
                      <image-view :height="300" :width="300" :image-id="supplier.mainPhotoId"></image-view>
                    </div>
                  </v-sheet>

                </v-col>
              </v-row>
              <v-row>
                <v-btn :to="'/supplier/' + sup_cd + '/review'">クチコミ投稿</v-btn>
                <v-btn :to="'/supplier/' + sup_cd + '/score'" class="ml-3">評価</v-btn>
              </v-row>
            </v-container>

            <!-- {{ selectedTab }} -->
            <v-tabs v-model="selectedTab">
              <v-tabs-slider></v-tabs-slider>
              <v-tab :key="1">基本情報</v-tab>
              <v-tab :key="2">対応工程</v-tab>
              <v-tab :key="3">評価</v-tab>
              <v-tab :key="4">クチコミ</v-tab>
              <v-tab :key="5">写真</v-tab>
              <v-tab :key="6">地図</v-tab>
              <v-tab :key="7">発注履歴</v-tab>
            </v-tabs>
            <div v-if="selectedTab === 0">
              <SupplierBasic :supplier="supplier"></SupplierBasic>
            </div>
            <div v-if="selectedTab === 1">
              <SupplierProcess :processGroups="supplier.processGroups"></SupplierProcess>
            </div>
            <div v-if="selectedTab === 2">
              <SupplierScore :score="scores" :features="features"></SupplierScore>
            </div>
            <div v-if="selectedTab === 3">
              <SupplierReviews :reviews="reviews"></SupplierReviews>
            </div>
            <div v-if="selectedTab === 4">
              <SupplierPhotos
                  :cat1="supplier.imageMap.cat1"
                  :cat2="supplier.imageMap.cat2"
                  :cat3="supplier.imageMap.cat3"
              ></SupplierPhotos>
            </div>
            <div v-if="selectedTab === 5">
              <SupplierMap :address1="supplier.address1" :address2="supplier.address2" :address3="supplier.address3"></SupplierMap>
            </div>
            <div v-if="selectedTab === 6">
              <SupplierOrders :supplierId="sup_cd"></SupplierOrders>
            </div>


          </v-col>

          <!-- 右のペーン モバイルの時は下に回り込ませる-->
          <v-col cols="2" class="pa-0" >
            <h6 class="mb-2">類似仕入先</h6>

            <v-card class="mb-2" v-for="sp in similar_suppliers" :key="sp.name" outlined>

              <v-list-item three-line>
                <v-list-item-content>

                  <div class="overline">
                    <router-link :to="{ name: 'supplier', params: { sup_cd: '000260' }}">
                      <p style="line-height: 1.5">{{sp.name}}</p>
                    </router-link>
                  </div>

                  <v-rating
                      background-color="white"
                      color="yellow accent-4"
                      v-model="sp.avg_score"
                      dense
                      readonly
                      half-increments
                      size="18"
                  ></v-rating>

                </v-list-item-content>

                <v-list-item-avatar
                    tile
                    size="40"
                    color="grey"
                ></v-list-item-avatar>
              </v-list-item>

            </v-card>

          </v-col>
        </v-row>
      </v-container>


    </div>
</template>
<script>
import ObjectParamSupport from "../../components/ObjectParamSupport";
import BaseView from "../../components/BaseView";
import SupplierBasic from "./SupplierBasic";
import SupplierProcess from "./SupplierProcess";
import SupplierScore from "./SupplierScore";
import SupplierReviews from "./SupplierReviews";
import SupplierPhotos from "./SupplierPhotos";
import SupplierMap from "./SupplierMap";
import SupplierOrders from "@/views/supplier/SupplierOrders";
import SupplierModel from "@/views/supplier/model/SupplierModel";

import SupplierAPI from "@/apis/SupplierAPI"
import EvaluateAPI from "@/apis/EvaluateAPI";
import SupplierFeatureAPI from "@/apis/SupplierFeatureAPI";

export default {
    mixins:[BaseView,ObjectParamSupport,SupplierModel],
    components: {
        SupplierBasic,SupplierProcess,SupplierScore,SupplierReviews,SupplierPhotos,SupplierMap,SupplierOrders
    },
    props: {
        sup_cd:String
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},

        selectedTab:0,


        scores:[
          {
            evaluateItemCd:"",
            score:0,
            evaluateItemName:"",
            evaluateCount:0,
            ignore:true,
          },
        ],

        features:[
          {
            id:0,supplierId:0,featureClass:"S",content:"",userId:0,
          }
        ],


      reviews:[
            {
                id:123,
                dt:"2020/06/25",
                vendor_name:"大野製作所",
                staff_name:"霜上 かよ",
                content:"通常納期6日のブロックを特急依頼で3時間で対応してもらいました。口の悪い社長ですので評価が低くなっていましたが、実は理解のある協力的な方なのだと感じました。",
                images:[12,15,17],
            },
            {
                id:124,
                dt:"2020/06/23",
                vendor_name:"津幡メッキ工業",
                staff_name:"木野しょうこ",
                content:"粟津工場向けのブラケットでメッキ剥がれ確認。再メッキ依頼を行なったが、「材料が悪い」と逆にクレームを受けました。",
                images:[],
            },
        ],

      similar_suppliers:[
        {
          name:"大里工業(株)",
          avg_score:4.5,
        }
        ,{
          name:"(株)ファーストカット",
          avg_score:3,
        }
      ],


        pager:{},
        errors:{},
    }),
    computed: {

    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){
            let p = this.getObjectParam();
            if (p){
                // パラメータの転写
            }
            this.fetchData(this.sup_cd)
        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(a => SupplierAPI.get(this.sup_cd))
                    .then(res => this.makeDisplayData(res))
                    .then(a => EvaluateAPI.getEvaluate(this.sup_cd))
                    .then(res => this.setupScoreData(res))
                    .then(a => SupplierFeatureAPI.list(this.sup_cd))
                    .then(res => this.setupFeatureData(res))
                    .catch(function(err) {
                        window.logger.error(err)
                        self.showErrorToast("データの取得に失敗しました。");
                    })
                    .finally(()=>{
                        self.isLoading = false;
                    })
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

        setupScoreData(data){
          console.log("setupScoreData",data)

          this.scores.splice(0)

          data.forEach(a => {
            this.scores.push({
              evaluateItemCd:a.evaluateItemCd,
              score:a.score,
              evaluateCount:a.evaluateCount,
              evaluateItemName:this.getEvaluateItemName( a.evaluateItemCd )
            })

          });
        },

        setupFeatureData(data){
          console.log("setupFeatureData",data)

          this.features.splice(0);
          data.forEach(a => {
            this.features.push({
              id:a.id,
              featureClass:a.featureClass,
              content:a.content,
              supplierId:a.supplierId,
              userId:a.userId,
            })
          })

        },

    },

}
</script>
<style lang="scss" scoped>

  table.basicinfo {
    th {
      font-weight: normal;
      padding-right: 1rem;
    }
  }


</style>
